// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"pop-over_popoverContainer__1NLzy","content":"pop-over_content__2Xmme","arrow":"pop-over_arrow__11tIz","icon":"pop-over_icon__3piC-"};